const TELEPHONE = {
  href: 'tel:+34928368335',
  number: '928 368 335'
}

const DEFAULT = 'default'

const COMPLAINTS_URL = 'https://autgc.sedelectronica.es/info.0'

/*
const SOCIAL_MEDIA = [
  {
    rrss: []
  }
]
*/
const SOCIAL_MEDIA = [
//   {
//     name: 'Twitter',
//     icon: 'twitter',
//     link: 'https://www.twitter.com/GVAatmv/'
//   }
//    ,
//    {
//      name: 'Youtube',
//      icon: 'youtube',
//      link: 'https://www.youtube.com/watch?v=iz9z0LzpNdU'
//    },
//    {
//      name: 'Facebook',
//      icon: 'facebook',
//      link: 'https://www.facebook.com/ATMV'
//    },
//
//    {
//      name: 'Instagram',
//      icon: 'instagram',
//      link: 'https://www.instagram.com/ATMV/'
//    }
]
const ADDRESS = null

const EMAIL_ADDRESS = {
  username: 'tarjetas',
  domain: 'autgc.org'
}

const GENERAL_TRANSPORT_CONDITIONS_URL = 'https://autgc.org/movilidad/'

export {
  TELEPHONE,
  COMPLAINTS_URL,
  SOCIAL_MEDIA,
  ADDRESS,
  EMAIL_ADDRESS,
  GENERAL_TRANSPORT_CONDITIONS_URL,
  DEFAULT
}
